/*
 * Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AvatarUrlPipe } from './avatar-url.pipe';
import { AvatarImageComponent } from './avatar-image/avatar-image.component';



@NgModule({
  declarations: [AvatarUrlPipe, AvatarImageComponent],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [AvatarUrlPipe, AvatarImageComponent]
})
export class AvatarModule { }
